// react components
import React from 'react'

// serializers
import {
    ContentTypeDetailBlockFieldSetFieldsOptionTypes,
    ContentTypeFieldTypes,
} from 'serializers/site'

// props
type DetailRow825Props = {
    children?: React.ReactNode
    fieldOptions: ContentTypeDetailBlockFieldSetFieldsOptionTypes | undefined
    fieldSettings: ContentTypeFieldTypes | undefined
    isError?: boolean
    isRich?: boolean
    rowId: string
    title: string
    value: string
}

// main
export const DetailRow825: React.FC<DetailRow825Props> = React.memo(({
    children,
    fieldOptions,
    fieldSettings,
    isError,
    isRich,
    rowId,
    title,
    value,
}) => {

    const hideIfEmpty = fieldOptions?.hideIfEmpty
    if (!value && hideIfEmpty) return null
    if (fieldOptions?.hideIfNotStaff) return null
    if (fieldOptions?.hideIfNotSuperuser) return null

    return (
        <div className={`detail-component-row-825 ${rowId} ${isRich ? 'RichTextField' : (fieldSettings?.fieldType || 'error')}${isError ? ' error' : ''}`}>
            <p className='dcr-title'>
                <span>{title}</span>
            </p>
            <div className='dcr-value'>
                <div className='dcr-value-wrap'>
                    {children
                        ? <div>{children}</div>
                        : <p>{value}</p>
                    }
                </div>
            </div>
        </div>
    )
})
